import { MdOutlineFormatListNumbered, MdStorefront } from "react-icons/md";
import { LuUsers } from "react-icons/lu";
import { PiIdentificationBadge } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import { CardLinkButton } from "../../components/CardLinkButton";
import { useAuth } from "../../hooks/auth";
import { useFulfillmentPriorityAccess } from "../../hooks/useFulfillmentPriorityAccess";
import { permissions } from "../../shared/Permissions";

import * as S from "./styles";

export function Settings() {
  const { t } = useTranslation();
  const { hasPermission } = useAuth();
  const { canAccess: canAccessFulfillmentPriority } =
    useFulfillmentPriorityAccess();

  return (
    <S.SettingsContainer>
      <S.SettingsCardButtonContainer>
        {hasPermission(permissions.settings.user) && (
          <CardLinkButton
            href="/settings/users"
            title={t("users")}
            description={t("usersDescription")}
          >
            <LuUsers />
          </CardLinkButton>
        )}
        {hasPermission(permissions.settings.stores) && (
          <CardLinkButton
            href="/settings/stores"
            title={t("stores")}
            description={t("storesDescription")}
          >
            <MdStorefront />
          </CardLinkButton>
        )}
        {hasPermission(permissions?.settings?.roles) && (
          <CardLinkButton
            href="/settings/roles"
            title={t("roles")}
            description={t("rolesDescription")}
          >
            <PiIdentificationBadge />
          </CardLinkButton>
        )}
        {canAccessFulfillmentPriority && (
          <CardLinkButton
            href="/settings/fulfillment-priority"
            title={t("fulfillmentPriority")}
            description={t("fulfillmentPriorityDescription")}
          >
            <MdOutlineFormatListNumbered />
          </CardLinkButton>
        )}
      </S.SettingsCardButtonContainer>
    </S.SettingsContainer>
  );
}
